import React from "react";
import { Briefcase, MapPin } from "lucide-react";

export default function Experience({ experiences = [] }) {
    return (
        <section id="experience" data-testid="experience-section" className="relative py-24 md:py-32 border-t border-white/5">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="mb-14">
                    <div className="mono-label mb-4">03 · Journey</div>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tighter">
                        Built and shipped at <span className="text-brand">scale</span>.
                    </h2>
                </div>

                <ol className="relative space-y-12 border-l border-white/5 ml-2 pl-8">
                    {experiences.map((exp, idx) => (
                        <li
                            key={exp.id || idx}
                            data-testid={`experience-item-${idx}`}
                            className="relative group"
                        >
                            <span className="absolute -left-[37px] top-1 flex h-5 w-5 items-center justify-center rounded-full bg-ink-900 border border-brand/60">
                                <span className="h-2 w-2 rounded-full bg-brand" />
                            </span>
                            <div className="grid lg:grid-cols-12 gap-6">
                                <div className="lg:col-span-3 space-y-2">
                                    <div className="mono-label">
                                        {exp.period_start} — {exp.current ? "Present" : exp.period_end}
                                    </div>
                                    {exp.current && (
                                        <span className="inline-block px-2 py-0.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 text-xs font-mono">
                                            Current
                                        </span>
                                    )}
                                </div>

                                <div className="lg:col-span-9 p-6 rounded-xl border border-white/5 bg-ink-800/50 hover:border-brand/30 hover:-translate-y-0.5 transition-all">
                                    <div className="flex flex-wrap items-baseline justify-between gap-2">
                                        <h3 className="font-display text-2xl text-white tracking-tight">{exp.role}</h3>
                                        <div className="flex items-center gap-2 text-brand">
                                            <Briefcase size={14} />
                                            <span className="text-sm font-medium">{exp.company}</span>
                                        </div>
                                    </div>
                                    {exp.location && (
                                        <div className="mt-2 flex items-center gap-2 text-ink-300 text-xs">
                                            <MapPin size={12} />
                                            {exp.location}
                                        </div>
                                    )}
                                    <p className="mt-4 text-ink-200 leading-relaxed">{exp.description}</p>

                                    {exp.achievements?.length > 0 && (
                                        <ul className="mt-5 space-y-2.5">
                                            {exp.achievements.map((a, i) => (
                                                <li key={i} className="flex gap-3 text-sm text-ink-200">
                                                    <span className="mt-1.5 h-1 w-1 rounded-full bg-brand flex-shrink-0" />
                                                    <span>{a}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                    {exp.tech?.length > 0 && (
                                        <div className="mt-5 flex flex-wrap gap-1.5">
                                            {exp.tech.map((t) => (
                                                <span
                                                    key={t}
                                                    className="font-mono text-xs px-2.5 py-1 rounded-md bg-ink-700/60 border border-white/5 text-ink-100"
                                                >
                                                    {t}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
